"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApdexTracker = exports.ApdexEventName = exports.AnalyticsEventName = exports.default = void 0;
var analyticsEventName_1 = __importDefault(require("./analyticsEventName"));
exports.AnalyticsEventName = analyticsEventName_1.default;
var apdexEventService_1 = require("./apdexEventService");
Object.defineProperty(exports, "ApdexTracker", { enumerable: true, get: function () { return apdexEventService_1.ApdexTracker; } });
var apdexEventsName_1 = require("./apdexEventsName");
Object.defineProperty(exports, "ApdexEventName", { enumerable: true, get: function () { return apdexEventsName_1.ApdexEventName; } });
var track_1 = __importDefault(require("./track"));
exports.default = track_1.default;
var trackLogin_1 = __importDefault(require("./trackLogin"));
var trackLogout_1 = __importDefault(require("./trackLogout"));
/*
 * Necessary functionality in order to track login & logout clicks for all templates.
 * Currently calling these functions here is a necessary hack as there isn't a better
 * place where to call them. They should be moved when an opportunity comes.
 */
(0, trackLogout_1.default)();
(0, trackLogin_1.default)();
(0, apdexEventService_1.initApdexEventListener)();
